class DetlightScrollZoom {
  constructor(elements) {
    this.elements = elements;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    const isDesktop = window.innerWidth >= 750;

    // Desktop keeps the plain, static text (no zoom); only mobile gets the
    // scroll-linked zoom effect.
    if (isDesktop) {
      this.elements.forEach((el) => {
        el.style.transform = '';
      });
      this.ticking = false;
      return;
    }

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;
    const minScale = 1;
    const scaleRange = 0.12;

    this.elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const elementCenter = rect.top + rect.height / 2;
      const distanceFromCenter = Math.abs(elementCenter - viewportCenter);
      const closeness = 1 - Math.min(distanceFromCenter / viewportHeight, 1);
      const scale = minScale + closeness * scaleRange;

      el.style.transform = `scale(${scale.toFixed(3)})`;
    });

    this.ticking = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll(
    '[id$="__hero_gXLNMB"] [class*="__text_FkUejh"], [id$="__hero_gXLNMB"] [class*="__text_NL63CH"]'
  );
  if (elements.length) {
    new DetlightScrollZoom(elements);
  }
});
